import { vservice } from '@niknevis/vue-modules'
import InertiaService from '@/modules/shared/helpers/http/services/inertia.service'
import { AdminUserRoutes } from '@/modules/user/routes/admin-user.route'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Data } from '@/modules/shared/models/data'
import {
  StoreUserRequestModel,
  UpdatePasswordRequestModelInAdmin,
  UpdateUserAccessibilityRequestModel,
  UpdateUserIdentityRequestModel,
  UserUpdateSettingRequestModel
} from '@/modules/user/models/user-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { UpdateBankAccountRequestModel } from '@/modules/bank-account/models/bank-account-request.model'
import { BillingInfoRequestModel } from '@/modules/billing-info/models/billing-info-request.model'
import { WalletUpdateRequestModel } from '@/modules/wallet/models/wallet-request.model'

@vservice()
export class AdminUserService {
  constructor(
    private readonly inertiaService: InertiaService,
    private readonly routes: AdminUserRoutes
  ) {
  }

  userInfo(userId: number): Promise<Data<UserResourceInAdminModel>> {
    return HTTP.get(
      this.routes.infoComponent(userId)
    ).then(result => result.json())
  }

  updateUserInfo(userId: number, data: UpdateUserIdentityRequestModel) {
    return Inertia.put(
      this.routes.updateUserInfo(userId),
      data
    )
  }

  updatePassword(userId: number, data: UpdatePasswordRequestModelInAdmin) {
    return Inertia.put(
      this.routes.updatePassword(userId),
      data
    )
  }

  updateBankInfo(userId: number, data: UpdateBankAccountRequestModel) {
    return Inertia.post(
      this.routes.updateBankInfo(userId),
      data
    )
  }

  updateBillingInfo(userId: number, data: BillingInfoRequestModel) {
    return Inertia.put(
      this.routes.updateBillingInfo(userId),
      data
    )
  }

  walletUpdate(userId: number, data: WalletUpdateRequestModel) {
    return Inertia.put(
      this.routes.walletUpdate(userId),
      data
    )
  }

  updateAccessibility(userId: number, data: UpdateUserAccessibilityRequestModel) {
    return Inertia.put(
      this.routes.updateAccessibility(userId),
      data
    )
  }

  storeUser(data: StoreUserRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  updateSetting(userId: number, data: UserUpdateSettingRequestModel) {
    return Inertia.put(
      this.routes.updateSetting(userId),
      data
    )
  }
}